import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

function PasswordRulesDisplay({ rules }) {
  if (!rules || rules.length === 0) return null;

  return (
    <Stack spacing={1} sx={{ mt: 1 }}>
      {rules.map((rule, index) => (
        <Box
          key={rule.message || `rule-${index}`}
          display="flex"
          alignItems="center"
        >
          {rule.valid ? (
            <CheckCircleIcon color="success" sx={{ mr: 1, fontSize: 18 }} />
          ) : (
            <CancelIcon color="error" sx={{ mr: 1, fontSize: 18 }} />
          )}
          <Typography
            variant="body2"
            color={rule.valid ? "success.main" : "text.secondary"}
          >
            {rule.message}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}

export default PasswordRulesDisplay;
